import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { RelationType } from 'ogp/hooks/queryHooks/flexWorkers/useGetFlexWorkerProfile';
import { DateTime } from 'luxon';
import { PreferredWorkerColumnDefinition } from './preferred-worker-table.types';
import { VisibilityRule } from '../preferred-worker.types';
import { defaultCheckedInIndicator } from '../../shared/types/shift-detail-tables.types';

export const getPreferredWorkersTableData = (
  visibilityRules: VisibilityRule[]
): PreferredWorkerColumnDefinition[] => {
  return visibilityRules.flatMap((rule) =>
    rule.workers.map((worker) => {
      const isPlatformWorker = worker.workerType === 'PLATFORM';

      return {
        flexWorkerFullName: getFullNameWithInfix(worker),
        flexWorkerImage: {
          firstName: worker.firstName,
          lastName: worker.lastName,
          infix: worker.infix,
          imageUrl: worker.imageUrl,
          id: worker.id,
          relation: isPlatformWorker
            ? { id: worker.id }
            : { id: worker.id, relation: RelationType.PREFERRED_PARTNER_WORKER },
          isFlexWorker: isPlatformWorker,
          hasCandidateLevel: false,
          partnerName: worker.partnerName ?? undefined,
          isReplacement: false,
          employmentType: worker.employmentType,
          lenderCompanyName: worker.lenderCompanyName,
          includeCheckedInIndicator: defaultCheckedInIndicator,
        },
        status: worker.status,
        dateTime: {
          fromDateTime: DateTime.fromISO(rule.isoRuleStartTime),
          toDateTime: DateTime.fromISO(rule.isoRuleEndTime),
        },
      };
    })
  );
};
